import { render, staticRenderFns } from "./XAndZReport.vue?vue&type=template&id=21f7f80c"
import script from "./XAndZReport.vue?vue&type=script&lang=js"
export * from "./XAndZReport.vue?vue&type=script&lang=js"
import style0 from "./XAndZReport.vue?vue&type=style&index=0&id=21f7f80c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports